<template>
  <div class="ion-text-right">
    <img src="@arag/assets/img/cgm.png" />
  </div>
  <next-question-button @click="emitValues()" />
  <ion-modal
    :is-open="showConfirmation"
    :css-class="['c-autoheight-modal']"
    :backdropDismiss="false"
    @didDismiss="showConfirmation = false"
  >
    <ion-page>
      <div class="modal-content ion-padding ion-text-center">
        <modal-close />
        <roodie fillOuter="#5E58BE" :expression="'happy'" />
        <div>
          <p>
            <b>Ihr Termin wurde erfolgreich gebucht.</b>
          </p>
        </div>
      </div>
    </ion-page>
  </ion-modal>
</template>

<script>
import { IonModal, IonPage } from "@ionic/vue";
import NextQuestionButton from "./NextQuestionButton";
import Roodie from "../svg/Roodie";
import ModalClose from "../ModalClose";

export default {
  emits: ["done"],
  props: {
    question: {
      required: true,
      type: Object,
    },
  },
  components: {
    NextQuestionButton,
    Roodie,
    ModalClose,
    IonModal,
    IonPage,
  },
  data() {
    return {
      showConfirmation: false,
    };
  },
  methods: {
    emitValues() {
      // const toast = await toastController.create({
      //   message: "<img src='../../assets/icons/roodie.svg' />Ihr Termin wurde erfolgreich gebucht.",
      //   // duration: 5000,
      //   color: "light",
      //   position: "bottom",
      //   icon: "../../assets/icons/roodie.svg",
      //   buttons: [
      //     {
      //       text: "",
      //       role: "cancel",
      //       icon: "close",
      //       handler: () => {
      //         console.log("Cancel clicked");
      //       },
      //     },
      //   ],
      // });
      // toast.present();
      this.showConfirmation = true;
      setTimeout(() => {
        this.showConfirmation = false;
      }, 5000);
      this.$emit("done", {
        value: "Termin gebucht",
        id: this.question.id,
      });
    },
  },
};
</script>

<style></style>
